import React from 'react';

import { Node } from '@tiptap/core';
import { NodeViewContent } from '@tiptap/react';

function SectionBlock() {
  return (
    <section className="section-block mt-24">
      <NodeViewContent />
    </section>
  );
}

export const SectionBlockNodeExtention = Node.create({
  name: 'sectionBlockNodeExtension',
  content: 'block*',
  group: 'block',
  renderHTML() {
    return ['section', { class: 'section-block' }, 0] as const;
  },
});

export default SectionBlock;
